export default __webpack_public_path__ + "static/media/element_83.240e378d.webp";